export const tourSteps = [
    {target: 'funkgeraet', label: 'Hier findest du das Funkgerät'},
    {target: 'taskpanel', label: 'Hier steht, was zu tun ist'},
    {target: 'startTour', label: 'Hier kannst du den Rundgang jederzeit nochmals starten'}
]